import axios from 'axios';
import CONFIG from '../config.js';
import { getTelegramWebApp } from '../utils/telegram';

const axiosApiClient = axios.create({
  baseURL: `${CONFIG.API.BASE_URL}`,
});

axiosApiClient.interceptors.request.use(
  async config => {
    const TelegramWebApp = getTelegramWebApp();

    config.headers['X-MY-CSRF'] = 'fdsasf3wdxsxa';
    const token = TelegramWebApp?.initData;

    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  },
);

export default axiosApiClient;
